function toSearchParams(
  params: Record<string, unknown>,
  { appendArray = true, mergeKeys = false, nestedKeys = false }: Options = {},
) {
  function mapObject(params: Record<string, unknown>) {
    return Object.entries(params).reduce(
      (mapped, [key, value]) => {
        if (value === undefined || value === null) {
          return mapped;
        }

        if (typeof value === "boolean") {
          mapped.push([key, value ? "1" : "0"]);
          return mapped;
        }

        if (Array.isArray(value)) {
          value.forEach((value) =>
            mapped.push([`${key}${appendArray ? "[]" : ""}`, String(value)]),
          );
          return mapped;
        }

        if (typeof value === "number" || typeof value === "string") {
          mapped.push([key, value.toString()]);
          return mapped;
        }

        if (typeof value === "object") {
          if (nestedKeys) {
            const result = mapObject(value as Record<string, unknown>);

            result.forEach(([mapkey, mapvalue]) => {
              mapped.push([`${key}[${mapkey}]`, mapvalue]);
            });

            return mapped;
          }

          mapped.push(...mapObject(value as Record<string, unknown>));
          return mapped;
        }

        return mapped;
      },
      [] as [string, string][],
    );
  }

  const result = mapObject(params);

  if (mergeKeys) {
    return new URLSearchParams(
      Object.fromEntries(
        result.reduce((mapped, [key, value]) => {
          if (mapped.has(key)) {
            mapped.set(key, `${mapped.get(key)},${value}`);
          } else {
            mapped.set(key, value);
          }
          return mapped;
        }, new Map<string, string>()),
      ),
    );
  }

  return new URLSearchParams(result);
}
type Options = {
  // if a array indicator should be shown example: ?type[]=application
  appendArray?: boolean;
  // Merge multiple keys to a list example: ?list=1,2,3
  mergeKeys?: boolean;
  // object nested items as non flatten example: ?filters[campaign]=141123
  nestedKeys?: boolean;
};

export { toSearchParams };
